import React from 'react';
import Logo from './Logo';

const LandingFooter = ({ navigateTo }) => {
  const currentYear = new Date().getFullYear();

  const handleNavigate = (path) => {
    if (navigateTo) {
      navigateTo(path);
    } else {
      window.history.pushState(null, '', path);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <Logo size="md" variant="footer" showText={true} />
            <p className="text-gray-600 text-sm mt-4">
              Next-generation test automation powered by AI. Ship faster with confidence.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigate('/solutions/web-testing')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Web Testing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/solutions/mobile-testing')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Mobile Testing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/solutions/api-testing')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  API Testing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/solutions/visual-testing')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Visual Testing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/solutions/cross-browser')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Cross-Browser Testing
                </button>
              </li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigate('/features')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Features
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/pricing')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/changelog')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Changelog
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigate('/blog')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Blog
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/guides')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Guides
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/developer')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  API Reference
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/status')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Status
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigate('/about')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/careers')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Careers
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/press')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Press
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/contact')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Contact
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/partners')}
                  className="text-gray-600 hover:text-gray-900 text-sm transition-colors text-left"
                >
                  Partners
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links Row */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-wrap items-center gap-6 text-sm">
              <button 
                onClick={() => handleNavigate('/terms')}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => handleNavigate('/privacy')}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                Privacy Policy
              </button>
            </div>
            
            <div className="flex items-center space-x-6">
              <a 
                href="https://www.instagram.com/getlexa/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-500 transition-colors"
                aria-label="Instagram"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403.61.218 1.17.51 1.675 1.087.577.505.869 1.065 1.087 1.675.163.457.347 1.256.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427-.218.61-.51 1.17-1.087 1.675-.505.577-1.065.869-1.675 1.087-.457.163-1.256.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a4.92 4.92 0 01-1.675-1.087A4.92 4.92 0 011.96 18.58c-.163-.457-.347-1.256-.403-2.427C1.5 14.887 1.487 14.507 1.487 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427.218-.61.51-1.17 1.087-1.675A4.92 4.92 0 015.418 1.96c.457-.163 1.256-.347 2.427-.403C9.11 1.5 9.49 1.487 12 1.487zm0 3.294a7.219 7.219 0 100 14.438 7.219 7.219 0 000-14.438zm0 2.41a4.81 4.81 0 110 9.62 4.81 4.81 0 010-9.62zM18.406 5.594a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"/>
                </svg>
              </a>

              <a 
                href="https://x.com/RunLexa89562"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-500 transition-colors"
                aria-label="Twitter"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>

              <a 
                href="https://www.linkedin.com/company/lexarun/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-500 transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="mt-4 text-center text-sm text-gray-500">
            © {currentYear} Lexa Run LLC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
